/*eslint-disable*/
export const ROUTE_NAMES = {
  appleSignUp: '/appleSignUpSuccess',
  appleSignUpSuccess: '/appleSignUpSuccess/:nonce', // After signup success from Apple, BE redirects to this URL with a nonce
  appleSignUpFailure: '/appleSignUpFailure', // After signup failure from Apple, BE redirects to this URL
  appleSignUpFailureWithJson: '/appleSignUpFailure/:errorJson', // After signup failure from Apple, BE redirects to this URL with error JSON
  appleMusicConnect: '/appleMusicConnect',
  popupCheck: '/popupCheck',
};
